import { render } from "./CookiesFilter.vue?vue&type=template&id=61f52d6e&scoped=true"
import script from "./CookiesFilter.vue?vue&type=script&lang=js"
export * from "./CookiesFilter.vue?vue&type=script&lang=js"

import "./CookiesFilter.vue?vue&type=style&index=0&id=61f52d6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f52d6e"]])

export default __exports__